import Reveal from '@/components/feature/Reveal';
import SectionHeader from './SectionHeader';

const steps = [
  { n: '01', title: 'Entendemos', desc: 'Analizamos el negocio, problema y sistemas existentes.' },
  { n: '02', title: 'Diseñamos', desc: 'Definimos experiencia, arquitectura e integraciones.' },
  { n: '03', title: 'Construimos', desc: 'Desarrollamos el producto mediante iteraciones.' },
  { n: '04', title: 'Integramos', desc: 'Conectamos APIs, ERP, pagos y servicios externos.' },
  { n: '05', title: 'Lanzamos', desc: 'Implementamos infraestructura y llevamos la solución a producción.' },
  { n: '06', title: 'Evolucionamos', desc: 'Medimos, optimizamos y agregamos nuevas capacidades.' },
];

export default function Methodology() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="Metodología"
          title="De una idea a producción."
        />

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 70}>
              <div className="relative h-full rounded-lg border border-background-700/60 bg-background-900/50 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-accent-500/40">
                <span className="text-4xl font-bold font-heading text-transparent bg-clip-text bg-gradient-to-br from-primary-500/70 to-accent-500/70">
                  {s.n}
                </span>
                <h3 className="mt-3 text-lg font-bold font-heading text-foreground-950">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                  {s.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}